// icons
import { MdLocalShipping, MdInventory } from "react-icons/md";

const remisiones = {
  id: 'remisiones-group',
  type: 'group',
  roles: [200],
  breadcrumbs: false,
  children: [
    {
      id: 'remisiones',
      title: "Remisiones",
      type: 'item',
      breadcrumbs: false,
      icon: MdLocalShipping,
      url: '/ventas/remisiones'
    },
    {
      id: 'existencias-disponibles',
      title: "Existencias disponibles",
      type: 'item',
      breadcrumbs: false,
      icon: MdInventory,
      url: '/operaciones/existencias-disponibles',
      roles: [200]
    }
  ]
};

export default remisiones;